import { MatrixAxisOperation } from 'flow/service/actions/matrixModels/types';
import { Operation } from 'flow/service/changelog/types';

export const matrixOpToHistoryOp = {
  [MatrixAxisOperation.ADD]: Operation.Add,
  [MatrixAxisOperation.DELETE]: Operation.Remove,
};
